import { http } from './http_service';

//Get list of employer with paginate
export function listPage(obj){
    let params = {
        page:obj.page,
        recordsPerPage:obj.recordsPerPage,
        q:obj.q,
        selectedStatus:obj.selectedStatus,
        sort_direction:obj.sort_direction,
        sort_field:obj.sort_field
    }
    return http().get(`/employer/list-page`, {
        params:params
    });
}
//Get Single
export function single(id){
    return http().get(`/employer/single/${id}`);
}
//Add one
export function add(data){
    return http().post('/employer/add', data)
}
//Update
export function update(id, data){
    return http().post(`/employer/update/${id}`, data)
}
